import * as R from 'ramda';

/**
 * object {age:1, name: 'a'}
 * valueModifier:(value, key, object) => value
 */
export const mapValues = (object, valueModifier) => {
  return R.mapObjIndexed((value, key) => valueModifier(value, key, object), object);
}



// WEBPACK FOOTER //
// ./src/util/object-utils.js